import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import {NgModule, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TitleStrategy} from '@angular/router';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxsModule} from '@ngxs/store';
import {NgChartsModule} from 'ng2-charts';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideAppConfig} from './core/config/app-config-initializer';
import {ApiKeyInterceptor} from './core/services/api/api-key.interceptor';
import {CustomPageTitleStrategy} from './core/services/page-title-strategy';
import {SharedModule} from './shared/shared.module';
import { AuthModule, OidcSecurityService } from 'angular-auth-oidc-client';

@NgModule({
  imports: [
    // Angular
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,

    //Translation
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
        deps: [HttpClient],
      },
    }),

    // NgXs
    NgxsModule.forRoot([]),

    // Third Party
    NgChartsModule.forRoot(),

    // Features
    SharedModule,

    // Routing
    AppRoutingModule,

    // OIDC Authentication
    AuthModule.forRoot({
      config: {
        authority: 'https://keycloak.internal.buildspaceproject.eu/realms/buildspace', // Change to your Keycloak URL
        redirectUrl: window.location.origin + '/dashboard',
        postLogoutRedirectUri: window.location.origin,
        clientId: 'edc-ui', // Change to your client ID
        scope: 'openid profile email',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        // secureRoutes: ['https://your-api-server/protected'], // API endpoints that require authentication
      },
    }),
  ],
  declarations: [AppComponent],
  providers: [
    HttpClient,
    provideAppConfig(),

    {provide: HTTP_INTERCEPTORS, multi: true, useClass: ApiKeyInterceptor},
    {provide: TitleStrategy, useClass: CustomPageTitleStrategy},
    { provide: APP_INITIALIZER, useFactory: (oidcSecurityService: OidcSecurityService) => () => oidcSecurityService.checkAuth(), deps: [OidcSecurityService], multi: true }

  ],
  bootstrap: [AppComponent],
  exports: [TranslateModule],
})
export class AppModule {}
